<rsf-main-s1
  [rsf]="originalBody"
  [rsfAmendment]="rsfAmendment"
  [status]="status"
  [service]="service"
  [disabled]="true"
>
</rsf-main-s1>
